import api from '@/api'

export default {
  // 获取领队帐号列表
  getLeaderAccountByYouth (params) {
    return api({
      url: '/integration/leader/leaderListYouth',
      method: 'GET',
      params
    })
  },
  // 获取领队帐号列表，机构管理员
  getLeaderAccountByOrg (params) {
    return api({
      url: '/integration/leader/leaderListOrgan',
      method: 'GET',
      params
    })
  },
  // 获取领队帐号列表，系统管理员
  getLeaderAccountBySystem (params) {
    return api({
      url: '/integration/leader/leaderListSystem',
      method: 'GET',
      params
    })
  },
  // 获取领队帐号列表
  getLeaderAccount (params) {
    return api({
      url: '/integration/leader',
      method: 'GET',
      params
    })
  },
  // 添加领队员
  addLeader (data) {
    return api({
      url: '/leader/leaderAdd',
      method: 'POST',
      data
    })
  },
  // 修改领队员信息
  updateLeader (data) {
    return api({
      url: '/leader/leaderEdit',
      method: 'PUT',
      data
    })
  },
  // 查看领队员详细信息
  getLeaderInfo (uuid) {
    return api({
      url: `/integration/leader/leaderInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 删除领队员
  deleteLeader (uuid) {
    return api({
      url: `/leader/${uuid}`,
      method: 'DELETE'
    })
  },
  // 批量导入领队
  batchAddLeader (data) {
    return api({
      url: '/leader/import/excel',
      method: 'POST',
      data
    })
  }
}
